// Removes the plain white photo background from a product shot so it can float on colour.
// Same method as the homepage hero. Used by the box builder; results are cached per image.
(() => {
  'use strict';
  if (window.SbCutout) return;
  const knockOut = (d, w, h) => {
    const n = w * h;
    const mark = new Uint8Array(n);
    const queue = new Int32Array(n);
    let head = 0, tail = 0, border = 0, kr = 0, kg = 0, kb = 0;
    const seed = i => {
      border += 1;
      const p = i << 2, r = d[p], g = d[p + 1], b = d[p + 2];
      if (mark[i] || r < 226 || g < 226 || b < 226) return;
      let hi = r, lo = r;
      if (g > hi) hi = g; else if (g < lo) lo = g;
      if (b > hi) hi = b; else if (b < lo) lo = b;
      if (hi - lo > 16) return;
      mark[i] = 1; queue[tail++] = i; kr += r; kg += g; kb += b;
    };
    for (let x = 0; x < w; x++) { seed(x); seed(n - w + x); }
    for (let y = 1; y < h - 1; y++) { seed(y * w); seed(y * w + w - 1); }
    if (tail < border * 0.6) return null;
    kr /= tail; kg /= tail; kb /= tail;
    while (head < tail) {
      const i = queue[head++], p = i << 2, x = i % w;
      const r = d[p], g = d[p + 1], b = d[p + 2];
      for (let k = 0; k < 4; k++) {
        let j;
        if (k === 0) { if (x === 0) continue; j = i - 1; }
        else if (k === 1) { if (x === w - 1) continue; j = i + 1; }
        else if (k === 2) { if (i < w) continue; j = i - w; }
        else { if (i >= n - w) continue; j = i + w; }
        if (mark[j]) continue;
        const q = j << 2, rj = d[q], gj = d[q + 1], bj = d[q + 2];
        const dr = rj - r, dg = gj - g, db = bj - b;
        if (dr > 12 || dr < -12 || dg > 12 || dg < -12 || db > 12 || db < -12) continue;
        let hi = rj, lo = rj;
        if (gj > hi) hi = gj; else if (gj < lo) lo = gj;
        if (bj > hi) hi = bj; else if (bj < lo) lo = bj;
        if (lo < 105 || hi - lo > 36) continue;
        mark[j] = 1; queue[tail++] = j;
      }
    }
    if (tail < n * 0.12 || tail > n * 0.97) return null;
    let x0 = w, y0 = h, x1 = -1, y1 = -1, edges = 0;
    for (let y = 0, i = 0; y < h; y++) {
      for (let x = 0; x < w; x++, i++) {
        if (mark[i] === 1) { d[(i << 2) + 3] = 0; continue; }
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
        if ((x > 0 && mark[i - 1] === 1) || (x < w - 1 && mark[i + 1] === 1) || (y > 0 && mark[i - w] === 1) || (y < h - 1 && mark[i + w] === 1)) queue[edges++] = i;
      }
    }
    if (x1 < 0) return null;
    for (let e = 0; e < edges; e++) mark[queue[e]] = 2;
    for (let e = 0; e < edges; e++) {
      const i = queue[e], x = i % w, y = (i - x) / w;
      let best = -1, bestDist = 0;
      for (let dy = -2; dy <= 2; dy++) {
        const yy = y + dy;
        if (yy < 0 || yy >= h) continue;
        for (let dx = -2; dx <= 2; dx++) {
          const xx = x + dx;
          if (xx < 0 || xx >= w) continue;
          const j = yy * w + xx;
          if (mark[j]) continue;
          const q = j << 2;
          let dist = kr - d[q];
          if (kg - d[q + 1] > dist) dist = kg - d[q + 1];
          if (kb - d[q + 2] > dist) dist = kb - d[q + 2];
          if (dist > bestDist) { bestDist = dist; best = j; }
        }
      }
      if (best < 0 || bestDist < 24) continue;
      const p = i << 2, q = best << 2;
      let c = 0, span = kr - d[q];
      if (kg - d[q + 1] > span) { c = 1; span = kg - d[q + 1]; }
      if (kb - d[q + 2] > span) { c = 2; span = kb - d[q + 2]; }
      const key = c === 0 ? kr : c === 1 ? kg : kb;
      const a = Math.max(0, Math.min(1, (key - d[p + c]) / span));
      d[p] = d[q]; d[p + 1] = d[q + 1]; d[p + 2] = d[q + 2]; d[p + 3] = Math.round(a * 255);
    }
    const pad = Math.round(Math.max(x1 - x0, y1 - y0) * 0.02);
    x0 = Math.max(0, x0 - pad); y0 = Math.max(0, y0 - pad);
    x1 = Math.min(w - 1, x1 + pad); y1 = Math.min(h - 1, y1 + pad);
    return { x: x0, y: y0, w: x1 - x0 + 1, h: y1 - y0 + 1 };
  };
  const cuts = new Map();
  window.SbCutout = url => {
    if (!url) return Promise.resolve(null);
    if (cuts.has(url)) return cuts.get(url);
    const job = new Promise(resolve => {
      const source = new Image();
      source.crossOrigin = 'anonymous';
      source.decoding = 'async';
      source.onload = () => {
        try {
          const w = source.naturalWidth, h = source.naturalHeight;
          const canvas = document.createElement('canvas');
          canvas.width = w; canvas.height = h;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(source, 0, 0);
          const pixels = ctx.getImageData(0, 0, w, h);
          const box = knockOut(pixels.data, w, h);
          if (!box) { resolve(null); return; }
          ctx.putImageData(pixels, 0, 0);
          const out = document.createElement('canvas');
          out.width = box.w; out.height = box.h;
          out.getContext('2d').drawImage(canvas, box.x, box.y, box.w, box.h, 0, 0, box.w, box.h);
          out.toBlob(blob => resolve(blob ? URL.createObjectURL(blob) : null), 'image/png');
        } catch (_) { resolve(null); }
      };
      source.onerror = () => resolve(null);
      source.src = url;
    });
    cuts.set(url, job);
    return job;
  };
})();